import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { saveToken, saveUser } from '../../services/auth';
import Toast from '../../components/common/Toast';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  console.log('🔐 Attempting login...', { email: formData.email });

  try {
    const response = await authAPI.login(formData.email, formData.password);
    
    console.log('📡 Full response:', response);
    console.log('📦 Response data:', response.data);
    console.log('✅ Success:', response.data.success);
    
    if (response.data && response.data.success) {
      const { access_token, refresh_token, admin } = response.data.data;
      
      console.log('🎫 Tokens received:', { 
        hasAccessToken: !!access_token, 
        hasRefreshToken: !!refresh_token,
        admin: admin 
      });
      
      // Save tokens and user data
      saveToken(access_token);
      saveUser(admin);
      
      console.log('💾 Tokens saved to localStorage');
      
      setToast({
        show: true,
        message: 'Login successful! Redirecting...',
        type: 'success',
      });

      setTimeout(() => {
        console.log('🚀 Navigating to dashboard...');
        navigate('/');
      }, 1000);
    } else {
      console.error('❌ Response success is false or missing');
      throw new Error(response.data.message || 'Login failed');
    }
  } catch (error) {
    console.error('❌ Login error:', error);
    console.error('❌ Error response:', error.response);
    
    setToast({
      show: true,
      message: error.response?.data?.message || error.message || 'Invalid email or password',
      type: 'error',
    });
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="login-page">
      <Toast 
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, show: false })}
      />

      <div className="login-card">
        <div className="login-logo">
          <i className="bi bi-heart-pulse-fill"></i>
        </div>
        <h1 className="login-title">Nisa Care Admin</h1>
        <p className="login-subtitle">Sign in to your account</p>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="admin@nisa-care.com"
              value={formData.email}
              onChange={handleChange}
              required
              autoFocus
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              placeholder="••••••••"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Signing in...
              </>
            ) : (
              <>
                <i className="bi bi-box-arrow-in-right me-2"></i>
                Sign In
              </>
            )}
          </button>
        </form>

        <div className="text-center mt-4">
          <small className="text-muted">
            Default: admin@nisa-care.com / Admin@123
          </small>
        </div>
      </div>
    </div>
  );
};

export default Login;